<template>

<Tab>
    <div class="wraper grid">
        <section class="content text-w">

<h2>Як відкриті дані можуть зробити Слов’янськ комфортнішим?</h2>
<p>Це – інструмент для містян, який дозволяє моніторити порушення благоустрою та статус щодо їх усунення, перевіряти наявність дозволу на розміщення рекламного носія або – чи відповідає тимчасова споруда виданій технічній документації.</p>
<p>Проєкт створено на основі відкритих даних. Інформація оновлюються щоквартально.</p>

<p>Texty.org.ua у межах проєкту USAID/UK aid “Прозорість та підзвітність у державному управлінні та послугах/TAPAS” створили інтерактивну візуалізацію «Комфортний Слов’янськ», яка складається з трьох частин: Порушення благоустрою, Тимчасові споруди, Рекламні конструкції</p>
<p>Візуалізація реалізована на основі наборів відкритих даних, оприлюднених на Порталі відкритих даних Слов'янська: </p>

<ul>

<li><a href="https://opendata.slavrada.gov.ua/dataset/a2117df6-8776-404c-aa9d-7f0b9fe7e7bf" target="_blank">Дані про складені приписи про усунення порушень у сфері благоустрою</a>, </li>            
<li><a target="_blank" href="https://opendata.slavrada.gov.ua/dataset/86926065-2c11-443a-bb0c-6d0f6b444ae4">інформація про рекламні засоби</a>, </li>
<li><a href="https://opendata.slavrada.gov.ua/dataset/b912b9c1-ea15-46fb-9a50-d92de564654c" target="_blank">дані про розміщення тимчасових споруд у м. Слов'янськ</a> (АРІ).</li>
<li>та <a target="_blank" href="https://opendata.slavrada.gov.ua/dataset/26ddf0bc-af7f-4ceb-aa39-1d001995ee78">інформація про накладені штрафи за адміністративними протоколами про порушення благоустрою</a>, яка оприлюднюється Адміністративною комісією Слов’янської міської ради.</li>

</ul>

        </section>

        <section v-if="fines" class="informer-stripe full-width grid">
            <div class=content style="display: flex; flex-wrap: wrap; gap: 3em;">
                <div class="informer-box">
                    <pre><h1>{{ fines.totalFinesAmount }}</h1> <h4>грн</h4></pre> 
                    <p>Штрафів за порушення благоустрою було нараховано з початку {{ fines.year }} року</p>
                </div>

                <div class="informer-box">
                    <pre><h1>{{ fines.paidFinesAmount }}</h1> <h4>грн</h4></pre>
                    <p>Сплачено в бюджет за рішенням адміністративної комісії</p>
                </div>
            </div>
        </section>

        <section class="content text-w after-text">

<p>Відкритість цих даних у зручному форматі може допомогти мешканцям міста краще контролювати діяльність міської ради, роботу комунальних підприємств, які мають забезпечувати чистоту та порядок у місті; та брати участь у покращенні благоустрою міста. Така публічність і прозорість інформації може стати додатковим стимулом для підприємців  утримувати комерційні об'єкти в належному стані та бути більш соціально відповідальними за прилеглий публічний простір. А для представників влади відкриті дані стають запобіжником проти зловживань. </p>
<p>Ця візуалізація на основі відкритих даних допоможе запобігти й низці корупційних ризиків. Діяльність міської влади у сфері благоустрою стає прозорою і підзвітною мешканцям. Візуалізація дозволяє зрозуміти, наскільки ефективною є робота міських служб, які здійснюють перевірки, розміщують рекламні засоби чи видають дозвільну документацію. Публічність роботи працівників комунальних служб – це головний запобіжник від зловживань. Аналізуючи відкриті дані, можна виявляти потенційні конфілікти інтересів, що провокують вибіркове ставлення органів місцевого самоврядування або ухвалення неправомірних рішень.</p>
<p>Нарешті, аналізуючи візуалізацію даних, мешканці міста можуть звертатися до Слов’янської міської ради щодо вирішення найболючіших проблем благоустрою та за допомогою відкритих даних здійснювати контроль за їх вирішенням. </p>
<p>Візуалізація охоплює всі оприлюднені дані від січня 2019 року. Планується оновлення візуалізації щокварталу (січень, квітень, липень, жовтень).</p>

        </section>
    </div>
</Tab>

</template>

<script>
import Tab from './Tab'
import * as d3 from 'd3'
import * as d3_array from 'd3-array'

export default {
    name: 'about-tab',
    components: {
        Tab,
    },

    data() {
        return {
            fines: null,
        }
    }, 

    created() {
        this.loadData();
    },

    methods: {
        async loadData() {
            let admin_fines = await d3.csv('data/admin_fines.csv');            
            this.fines = compute_fines_stats(admin_fines)
        }
    }
}

function compute_fines_stats(fines_data) {
    let format = val => d3.format(',.0f')(val).replace(/,/g, ' ')

    fines_data = fines_data
        .filter(d => d.periodStartDate >= '2020-01-01' && d.periodEndDate <= '2021-01-01')
        
    let totalFinesAmount = format(d3_array.sum(fines_data, d => d.amountOfFinesImposed))
    let paidFinesAmount = format(d3_array.sum(fines_data, d => d.amountOfFinesPaid))

    return {
        year: 2020,
        totalFinesAmount,
        paidFinesAmount
    }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/base/variables';

.informer-box {
    background-color: #FFF7E3;
    padding: 3em;

    p {
        margin-bottom: 0;
    }
}

ul {
    margin-left: 2em;
    li {
        background: url('../assets/ic_download.svg') no-repeat 0 4px;
        padding-left: 30px;
    }
}

li {
    margin-bottom: 1em;
}


</style>